import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from './auth.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { CookieService } from 'ngx-cookie-service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(private authService: AuthService, private cookieService: CookieService) {}

  canActivate(): Observable<boolean> {
    return this.authService.checkSession().pipe(
      map((isAuthenticated: boolean) => {
        //Check if we have the user cookie, if we dont then they are automatically not authenticated, even if the session check passed (e.g. if the session cookie is present but expired, the session check might return false but we want to be extra sure)
        let user_str = this.cookieService.get("user");
        if (user_str == null || user_str == "") {
          isAuthenticated = false;
        }
        if (!isAuthenticated) {
            this.authService.RedirectToLogin();
        }
        return isAuthenticated;
      })
    );
  }
}
